export default __webpack_public_path__ + "static/media/diego.67366cef.webp";